<template>
  <div id="app">
    <nav-bar v-if="$route.path!=='/login' && $route.path!=='/infor'"></nav-bar>
    <div class="blank"></div>
    <v-modal ref="modal"></v-modal>
    <div id="loading" v-if="isLoading"></div>
    <router-view v-else/>
    <v-modal ref="modal">
      <div slot="slotA">
        <div style="display: flex; align-items: center;">
          <img :src="'https://static.gmic.cn/gmicpro/wechatqrcode.jpg?' + t"
            style="width: 100px; height: 100px; flex-shrink: 0; margin-right:10px;" alt="">
          <div>
            <p style="text-align: left;">添加小吉，加入 GMIC 交流群；及时获取开播提醒、GMIC日程更新、还有无门槛优惠劵和限量社群福利等着你噢。</p>
          </div>
        </div>
      </div>
      <div slot="slotB">
        <div style="display: flex; align-items: center;">
          <img src="./assets/images/xj2.jpg"
            style="width: 100px; height: 100px; flex-shrink: 0; margin-right:10px;" alt="">
          <div>
            <p style="text-align: left;">添加小吉微信，<br>预约嘉宾面对面</p>
          </div>
        </div>
      </div>
    </v-modal>
  </div>
</template>

<script>

import NavBar from './components/navbar'
import Modal from './components/Modal.vue'
import ModalApi from './components/ModalApi'
import modalEventBind from './components/ModalEventBind'

export default {
  mixins: [ModalApi],
  components: {
    [Modal.name]: Modal,
    NavBar: NavBar
  },
  name: 'App',
  data () {
    return {
      isLoading: false,
      timer: null,
      t: 0
    }
  },
  mounted () {
    modalEventBind(this.$refs.modal)
  },
  created () {
    let self = this
    self.t = Date.now()
    // console.log(self.t)
    self.timer = setTimeout(() => {
      self.isLoading = false
    }, 3000)
  },
  destroyed () {
    this.timer = null
  }
}
</script>

<style>
*{padding:0;border:0;margin:0;}
.blank {
  position: fixed;
  bottom: 0;
  height: 0;
  width: 100%;
  height: constant(safe-area-inset-bottom);
  background-color: #fff;
}
@supports (bottom: constant(safe-area-inset-bottom)) {
  body {
    padding-bottom: constant(safe-area-inset-bottom);
  }
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #666;
  max-width: 750px;
  margin:0 auto;
  padding:0;
}
#loading{
  width:100%;
  height:100vh;
  background-color: #000;
}
a:active{
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
}
pre{
  white-space: pre-wrap;           /* css-3 */
  white-space: -moz-pre-wrap;      /* Mozilla, since 1999 */
  white-space: -pre-wrap;          /* Opera 4-6 */
  white-space: -o-pre-wrap;        /* Opera 7 */
  word-wrap: break-word;           /* Internet Explorer 5.5+ */
}
</style>



// WEBPACK FOOTER //
// src/App.vue